import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, isRef as _isRef, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "config-container" };
var _hoisted_2 = { class: "config-block" };
var _hoisted_3 = { class: "dark-theme-mode-switch-container" };
var _hoisted_4 = { class: "config-row" };
var _hoisted_5 = { class: "config-option" };
var _hoisted_6 = {
    key: 0,
    class: "live2d-options-group"
};
var _hoisted_7 = { class: "config-row" };
var _hoisted_8 = { class: "config-option" };
var _hoisted_9 = { class: "config-block" };
var _hoisted_10 = { class: "config-row" };
var _hoisted_11 = { class: "config-option" };
var _hoisted_12 = { class: "config-block" };
var _hoisted_13 = { class: "config-row" };
var _hoisted_14 = { class: "config-option" };
var _hoisted_15 = {
    key: 0,
    class: "live2d-options-group"
};
var _hoisted_16 = { class: "config-row" };
var _hoisted_17 = { class: "config-option config-opacity-option" };
var _hoisted_18 = { class: "config-row" };
var _hoisted_19 = { class: "config-option" };
import { computed, nextTick, ref, watch } from "vue";
// import { useStore } from "@/store";
import { useStore } from "@/store";
import DarkThemeModeSelector from "@/components/custom/DarkThemeModeSelector.vue";
import ColorPicker from "@/components/common/ColorPicker.vue";
import Switch from "@/components/common/Switch.vue";
var placement = "right";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigBtn',
    setup: function (__props) {
        var store = useStore();
        var active = ref(false);
        var switchSize = ref("1.6rem");
        var selectedThemeColor = window.themeColor;
        watch(selectedThemeColor, function (newValue) {
            // 当 bindValue 发生变化时，触发 update:bind-value 事件
        });
        window.isConfigDrawerActive = active;
        // const switchAutoDarkThemeDefault = ref(store.isAutoSwitchDarkTheme);
        var switchAutoDarkThemeDefault = computed({
            get: function () {
                return store.isAutoSwitchDarkTheme; // 获取 pania 中的值
            },
            set: function (value) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        console.log("switchAutoDarkThemeDefault", value);
                        if (value !== store.isAutoSwitchDarkTheme) {
                            store.switchAutoSwitchDarkTheme();
                        }
                        return [2 /*return*/];
                    });
                });
            },
        });
        var switchShowUniverse = computed({
            get: function () {
                return store.isShowUniverse; // 获取 pania 中的值
            },
            set: function (value) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        console.log("switchShowUniverse", value);
                        if (value !== store.isShowUniverse) {
                            store.switchShowUniverse();
                        }
                        return [2 /*return*/];
                    });
                });
            },
        });
        var live2dStandbyOpacityValue = ref(window.getLive2dStandbyOpacity
            ? String(parseFloat(window.getLive2dStandbyOpacity()) * 100)
            : "50");
        var isShowLive2d = computed({
            get: function () {
                return store.isShowLive2d;
            },
            set: function (value) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log("isShowLive2d", value);
                                store.setLive2DShow(value);
                                return [4 /*yield*/, nextTick()];
                            case 1:
                                _a.sent();
                                if (value) {
                                    live2dStandbyOpacityValue.value = window.getLive2dStandbyOpacity
                                        ? window.getLive2dStandbyOpacity()
                                        : "0.5";
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }), live2dStandbyOpacity = computed({
            get: function () {
                // const opacity = window.getLive2dStandbyOpacity();
                // return typeof opacity === "number"
                //   ? opacity
                //   : parseInt(window.getLive2dStandbyOpacity() as string);
                if (parseFloat(live2dStandbyOpacityValue.value) < 1)
                    live2dStandbyOpacityValue.value = String(parseFloat(live2dStandbyOpacityValue.value) * 100);
                return parseInt(live2dStandbyOpacityValue.value);
                // 逆天小问题，直接使用注释的内容，不引入 live2dStandbyOpacityValue，会导致 n-slider 拖动效果无法更新，为什么？
                // 似乎答案是：返回值为函数返回值时似乎无法追踪过程的响应式变化（仅追踪值而不是函数），导致 get 值不会及时更新（参考 vue3 ref 响应式实现原理猜测结果，未知正确性）
                // 引用的是 live2dStandbyOpacity，为什么多加一个没有任何位置引用的中间变量 live2dStandbyOpacityValue 就可以实现组件渲染响应式了？
            },
            set: function (value) {
                window.setLive2dStandbyOpacity(String(value * 0.01));
                live2dStandbyOpacityValue.value = String(value); // 后加的
                console.log("live2dStandbyOpacity get", window.getLive2dStandbyOpacity());
            },
        }), isLive2DForceStandby = computed({
            get: function () {
                return window.live2dStatus === "forceStandby";
            },
            set: function (value) {
                if (value)
                    window.Live2DForceStandby();
                else
                    window.stopForceStandby();
            },
        });
        return function (_ctx, _cache) {
            var _component_CustomSVG = _resolveComponent("CustomSVG");
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            var _component_n_divider = _resolveComponent("n-divider");
            var _component_n_slider = _resolveComponent("n-slider");
            var _component_n_drawer_content = _resolveComponent("n-drawer-content");
            var _component_n_drawer = _resolveComponent("n-drawer");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(function () { return [
                        _createVNode(_component_n_button, {
                            class: "config-btn",
                            quaternary: "",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (active.value = true); })
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_component_n_icon, { size: "1.3rem" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_CustomSVG, { icon: "CloudSatelliteConfig" })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    default: _withCtx(function () { return [
                        _cache[9] || (_cache[9] = _createTextVNode(" 中控台配置 "))
                    ]; }),
                    _: 1
                }),
                _createVNode(_component_n_drawer, {
                    show: active.value,
                    "onUpdate:show": _cache[8] || (_cache[8] = function ($event) { return ((active).value = $event); }),
                    width: 350,
                    placement: placement
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_drawer_content, {
                            title: "中控台设置",
                            closable: "",
                            "native-scrollbar": false
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_n_divider, { class: "theme-switch-title" }, {
                                            default: _withCtx(function () { return _cache[10] || (_cache[10] = [
                                                _createTextVNode(" 亮暗色主题切换 ")
                                            ]); }),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_3, [
                                            _createVNode(DarkThemeModeSelector, {
                                                size: "55",
                                                initial: _unref(store).isDarkTheme,
                                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(store).switchDarkTheme()); })
                                            }, null, 8, ["initial"])
                                        ]),
                                        _createElementVNode("div", _hoisted_4, [
                                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "config-title" }, " 根据时间调整 ", -1)),
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(Switch, {
                                                    "bind-value": switchAutoDarkThemeDefault.value,
                                                    "onUpdate:bindValue": _cache[2] || (_cache[2] = function ($event) { return ((switchAutoDarkThemeDefault).value = $event); }),
                                                    "component-size": switchSize.value
                                                }, null, 8, ["bind-value", "component-size"])
                                            ])
                                        ]),
                                        _createVNode(_Transition, { name: "live2d-opacity-transition" }, {
                                            default: _withCtx(function () { return [
                                                (_unref(store).isDarkTheme)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                        _createElementVNode("div", _hoisted_7, [
                                                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "config-title" }, " 不显示星空背景 ", -1)),
                                                            _createElementVNode("div", _hoisted_8, [
                                                                _createVNode(Switch, {
                                                                    "bind-value": switchShowUniverse.value,
                                                                    "onUpdate:bindValue": _cache[3] || (_cache[3] = function ($event) { return ((switchShowUniverse).value = $event); }),
                                                                    "component-size": switchSize.value
                                                                }, null, 8, ["bind-value", "component-size"])
                                                            ])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]; }),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_n_divider, { class: "theme-switch-title" }, {
                                            default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                                                _createTextVNode(" 颜色配置 ")
                                            ]); }),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_10, [
                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "config-title" }, " 主题色 ", -1)),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(ColorPicker, {
                                                    "bind-value": _unref(selectedThemeColor),
                                                    "onUpdate:bindValue": _cache[4] || (_cache[4] = function ($event) { return (_isRef(selectedThemeColor) ? (selectedThemeColor).value = $event : null); }),
                                                    placement: "left-start"
                                                }, null, 8, ["bind-value"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_n_divider, { class: "config-row-title" }, {
                                            default: _withCtx(function () { return _cache[15] || (_cache[15] = [
                                                _createTextVNode(" live2d 配置 ")
                                            ]); }),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_13, [
                                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "config-title" }, " live2d 看板娘开关 ", -1)),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createVNode(Switch, {
                                                    "bind-value": isShowLive2d.value,
                                                    "onUpdate:bindValue": _cache[5] || (_cache[5] = function ($event) { return ((isShowLive2d).value = $event); }),
                                                    "component-size": switchSize.value
                                                }, null, 8, ["bind-value", "component-size"])
                                            ])
                                        ]),
                                        _createVNode(_Transition, { name: "live2d-opacity-transition" }, {
                                            default: _withCtx(function () { return [
                                                (_unref(store).isShowLive2d)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                        _createElementVNode("div", _hoisted_16, [
                                                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "config-title" }, " 看板娘待机透明度 ", -1)),
                                                            _createElementVNode("div", _hoisted_17, [
                                                                _createVNode(_component_n_slider, {
                                                                    value: live2dStandbyOpacity.value,
                                                                    "onUpdate:value": _cache[6] || (_cache[6] = function ($event) { return ((live2dStandbyOpacity).value = $event); }),
                                                                    step: 1
                                                                }, null, 8, ["value"])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_18, [
                                                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "config-title" }, " 是否强制待机 ", -1)),
                                                            _createElementVNode("div", _hoisted_19, [
                                                                _createVNode(Switch, {
                                                                    "bind-value": isLive2DForceStandby.value,
                                                                    "onUpdate:bindValue": _cache[7] || (_cache[7] = function ($event) { return ((isLive2DForceStandby).value = $event); }),
                                                                    "component-size": switchSize.value
                                                                }, null, 8, ["bind-value", "component-size"])
                                                            ])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]; }),
                                            _: 1
                                        })
                                    ])
                                ])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ], 64));
        };
    }
});
